import { render, staticRenderFns } from "./MatrixBox.vue?vue&type=template&id=64bcdbd1&scoped=true"
import script from "./MatrixBox.vue?vue&type=script&lang=js"
export * from "./MatrixBox.vue?vue&type=script&lang=js"
import style0 from "./MatrixBox.vue?vue&type=style&index=0&id=64bcdbd1&prod&lang=scss&scoped=true"
import style1 from "./MatrixBox.vue?vue&type=style&index=1&id=64bcdbd1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bcdbd1",
  null
  
)

export default component.exports